module.exports = __webpack_public_path__ + "img/horangit_5.703920be.png";